import { apiClient as d } from "../provider/create-provider.js";
function g(s) {
  const { isLoading: e, isError: i, isPending: t, isPaused: n, isSuccess: o, error: r, data: u } = d.assets.getAsset.useQuery({
    path: { id: (s == null ? void 0 : s.id) ?? "" }
  });
  return {
    isLoading: e,
    isError: i,
    isPending: t,
    isPaused: n,
    isSuccess: o,
    error: r,
    data: u
  };
}
export {
  g as useAssets
};
